const defaultTheme: Bera.SimpleTheme = {
  primary: '#00AFFF',
  secondary: '#000',
};

export default defaultTheme;
